function Page({ children }) {
  return <section className="page">{children}</section>;
}

export { Page };
